import axios from 'axios'
import { useState } from 'react'

export const useCancelRequest = () => {
  const [optionsCancelToken, setOptionsCancelToken] = useState()

  const getCancelToken = () => {
    const newToken = axios.CancelToken.source()
    if (optionsCancelToken) {
      optionsCancelToken.cancel()
    }
    setOptionsCancelToken(newToken)
    return newToken
  }
  return { getCancelToken }
}
